function selectionQuantityHandler(event) {
  var customPriceTemplate = `
<div class="product-info-price">
  <div class="price-box price-final_price" data-role="priceBox"> 
    <span class="special-price"> 
      <span class="price-container price-final_price tax weee" itemtype="http://schema.org/Offer">
        <span class="price-label">Special Price</span>
        <span data-price-amount="[[regular_price_per_item]]" data-price-type="finalPrice" class="price-wrapper ">
          <span class="price">[[special_price]]</span>
        </span>
        <meta itemprop="price" content="[[regular_price_per_item]]">
        <meta itemprop="priceCurrency" content="USD">
      </span>
    </span>
    <span class="old-price hide-on-grid">
      <span class="price-container price-final_price tax weee">
        <span class="price-label">Regular Price</span> 
        <span data-price-amount="[[regular_price_per_item]]" data-price-type="oldPrice" class="price-wrapper " style="">
          <span class="price">[[regular_price]]</span>
        </span>
      </span>
    </span>
  </div>
  <span class="you-save">[[you_Save]]</span>
</div>`;
  let priceNode = document.querySelector('.price .price__regular');
  let element = event.currentTarget;
  if(element.dataset.specialPrice && element.dataset.youSave){
    customPriceTemplate = customPriceTemplate.replace('[[regular_price_per_item]]', element.dataset.regularPricePerItem)
    customPriceTemplate = customPriceTemplate.replace('[[regular_price]]', element.dataset.regularPrice)
    customPriceTemplate = customPriceTemplate.replace('[[special_price]]', element.dataset.specialPrice)
    customPriceTemplate = customPriceTemplate.replace('[[you_Save]]', element.dataset.youSave)
  }else {
    customPriceTemplate = customPriceTemplate.replace('[[regular_price_per_item]]', element.dataset.regularPricePerItem)
    customPriceTemplate = customPriceTemplate.replace('[[regular_price]]', '')
    customPriceTemplate = customPriceTemplate.replace('[[special_price]]', element.dataset.regularPrice)
    customPriceTemplate = customPriceTemplate.replace('[[you_Save]]', '')
  }
  priceNode.innerHTML = customPriceTemplate;
  let inputSellingPlan = element.parentElement.querySelector('input[name=selling_plan]')
  inputSellingPlan.checked = 'checked'
}

var optionsSelectionQuantity = document.querySelectorAll('ul.quantity.prices-tier > li.product-option > label');
optionsSelectionQuantity.forEach((element) => {
  element.addEventListener('click',selectionQuantityHandler)
})
var showAutoDeliveryModal = document.querySelector('[js-auto-delivery-modal]');
showAutoDeliveryModal.addEventListener('click',() => {
  var modal = document.getElementById('auto-delivery-modal');
  modal.classList.add('_show');
});
var hideAutoDeliveryModal = document.querySelectorAll('.custom-modal-wrapper .action-close, .custom-modal-wrapper .modal-overlay');
hideAutoDeliveryModal.forEach((element) => {
  element.addEventListener('click',() => {
    var modal = document.getElementById('auto-delivery-modal');
    modal.classList.remove('_show');
  });
});

















